import { createSlice } from "@reduxjs/toolkit";

export const locationsSlice = createSlice({
  name: "locations",
  initialState: { locations: [], status: "idle", error: null },
  reducers: {
    setLocations: (state, action) => {
      if (!Array.isArray(action.payload)) return;
      state.locations = action.payload;
      state.status = "ready";
      state.error = null;
    },
    setLocationsStatus: (state, action) => {
      state.status = action.payload?.status || "idle";
      state.error = action.payload?.error ?? null;
    },
    clearLocations: (state) => {
      state.locations = [];
      state.status = "idle";
      state.error = null;
    },
  },
});

export const { setLocations, setLocationsStatus, clearLocations } =
  locationsSlice.actions;

export default locationsSlice.reducer;
